import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import userReducer from '../features/user/userSlice';
import { api } from '../features/api/api'
import { emptySplitApi } from '../features/api/emptyApi'
import '../features/api/enhancedEndpoints'
import { rtkQueryErrorLogger } from './middlewares';

export const store = configureStore({
	reducer: {
		counter: counterReducer,
		user: userReducer,
		[api.reducerPath]: api.reducer,
		[emptySplitApi.reducerPath]: emptySplitApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(api.middleware, emptySplitApi.middleware, rtkQueryErrorLogger),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
